var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},[_c('router-link',{staticClass:"tab-item",attrs:{"tag":"div","to":"/recommend"}},[_c('span',[_vm._v("个性推荐")])]),_vm._v(" "),_c('router-link',{staticClass:"tab-item",attrs:{"tag":"div","to":"/radio"}},[_c('span',[_vm._v("主播电台")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-715aac85","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tab/tab.vue
// module id = null
// module chunks = 